import { render, staticRenderFns } from "./GridFlexAlignment.vue?vue&type=template&id=8d0c81ac"
import script from "./GridFlexAlignment.vue?vue&type=script&lang=js"
export * from "./GridFlexAlignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports